export const acronyms = [
    { value: "", label: "Bez skratky" },
    { value: "PD", label: "PD - Predchádzajúci držiteľ" },
    { value: "PD E", label: "PD E - Predchádzajúci držiteľ (cezhraničná preprava)" },
    { value: "PRO", label: "PRO - Príjemca odpadu" },
    { value: "PRO E", label: "PRO E - Príjemca odpadu (cezhraničná preprava)" },
    { value: "DO", label: "DO - Odovzdanie do domácnosti" },
    { value: "VD", label: "VD - Využitie v domácnosti" },
    { value: "SKO", label: "SKO - Stav konca odpadu" },
    { value: "PO", label: "PO - Príprava na opätovné použitie" },
    { value: "VP", label: "VP - Vedľajší produkt" },
    { value: "SB", label: "SB - Spätný zber" },
    { value: "SVZ", label: "SVZ - Skladovanie výkopovej zeminy" },
    { value: "PS", label: "PS - Prekládková stanica" },
    { value: "SZ", label: "SZ - Spätné zasypávanie" },
    { value: "ZO", label: "ZO - Zostatok z roka, za ktorý sa podáva ohlásenie" },
    { value: "ZPR", label: "ZPR - Zostatok z prechádzajúceho roka" }
];